module.exports = __webpack_public_path__ + "img/discount.29caf950.svg";